<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Finalizar Atendimento"
    >
        <Form
            :plantao-id="plantaoId"
            :data="data"
            ref="Form"
            @save="$emit('save')"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="outline-success"
            >
                Finalizar atendimento
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
    },
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
}
</script>